var _ = require('./utils/lib.js');
var GiftOptions = require('./gift-options/controller.js');

var main = function () {
  giftOptions = window.giftOptions || {};
  giftOptions.controller = new GiftOptions();
};

if (window.deferApp) {
  window.onload = function () {
    main();
  };
} else {
  _.ready(function () {
    main();
  });
}
